// Cuenta atrás del prezzo di lancio (snippets/amorea-lancio.liquid). La fecha de fin es fija y la misma
// para todos (data-am-fine, segundos Unix); al llegar a cero se quitan los avisos de la página, salvo que
// lleven data-am-ciclo (SOLO VISTA): entonces la fecha salta ese tramo, como en el Liquid.
// Se carga desde varios sitios de la misma página: solo arranca una vez.
(() => {
  if (window.amoreaLancio) return;
  window.amoreaLancio = true;

  const due = (n) => String(n).padStart(2, '0');

  const aggiorna = () => {
    const ora = Date.now() / 1000;
    for (const el of document.querySelectorAll('[data-am-fine]')) {
      let resto = Math.floor(Number(el.dataset.amFine) - ora);
      const ciclo = Number(el.dataset.amCiclo);
      if (!(resto > 0) && ciclo > 0) {
        const fine = Number(el.dataset.amFine) + ciclo * (Math.floor(-resto / ciclo) + 1);
        el.dataset.amFine = fine;
        resto = Math.floor(fine - ora);
      }
      if (!(resto > 0)) {
        el.closest('[data-am-lancio]')?.remove();
        continue;
      }
      const valori = {
        d: Math.floor(resto / 86400),
        H: due(Math.floor(resto / 3600)),
        h: due(Math.floor((resto % 86400) / 3600)),
        m: due(Math.floor((resto % 3600) / 60)),
        s: due(resto % 60),
      };
      for (const u of el.querySelectorAll('[data-u]')) {
        const v = String(valori[u.dataset.u]);
        if (u.textContent !== v) u.textContent = v;
      }
    }
  };

  const avvia = () => {
    aggiorna();
    setInterval(aggiorna, 1000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia, { once: true });
  } else {
    avvia();
  }
})();
